import * as angular from "angular";
import {IController} from "angular";

export class AgentsAssignTableComponent implements IController {
  columns: any;
  assignData: any;
  onAssign: Function;

  constructor() {

  }

  $onInit() {

  }

  setEvents() {
    const div1 = document.getElementById('agents-assign-table').querySelectorAll("#header")[0];
    const div2 = document.getElementById('agents-assign-table').querySelectorAll('.md-virtual-repeat-scroller')[0];

    div2.addEventListener('scroll', e => {
      div1.scrollTop = div2.scrollTop;
      div1.scrollLeft = div2.scrollLeft;
    }, {passive: true})
  }

}

angular
  .module('bringoz.admin.agents')
  .component('agentsAssignTable', {
    bindings: {
      columns: '<',
      assignData: '<',
      onAssign: '&'
    },
    template: require('./agents-assign-table.html').default,
    controller: AgentsAssignTableComponent
  });
